<script setup>

import Footer from "@/components/Footer.vue";
import HomeHeader from "@/components/HomeHeader.vue";
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import axios from "axios";
import {useRoute, useRouter} from "vue-router";
import {useHead} from "@vueuse/head";
import {useI18n} from "@/i18n";

const route = useRoute()
const router = useRouter()
const {t} = useI18n()
const blogList = ref(null);
const Keywords = ref()
const current = ref(1)

async function get_blog_list() {
  try {
    let url = '/api/blogs';
    const title = route.query.blog_title;
    const page = Number(route.query.page);
    const category = route.query.category;
    const params = new URLSearchParams();

    if (title) {
      params.append('blog_title', title);
    }
    if (page) {
      params.append('page', page);
    }
    if (category) {
      params.append('category', category);
    }

    url = url + '?' + params.toString();
    const response = await axios.get(url);
    blogList.value = response.data;
  } catch (error) {
    console.log(error);
  }
}

const lastPage = computed(() => {
  return Math.ceil(blogList.value.count / 12)
})

const prevPage = computed(() => {
  if (current.value > 1) {
    return current.value - 1;
  } else {
    return 1
  }
})

const nextPage = computed(() => {
  if (current.value < lastPage.value) {
    return current.value + 1
  } else {
    return current.value
  }
})

const pages = computed(() => {
  const pages = []
  for (let i = 1; i <= lastPage.value; i++) {
    if (i === current.value || i === lastPage.value || (i >= current.value - 1 && i <= current.value + 1)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...')
    }
  }
  return pages
})

function searchBlog() {
  const search = Keywords.value.trim()
  router.push({
    query: {blog_title: search}
  })
}

function formatDate(dateString) {
  const date = new Date(dateString);
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
}

function getPageFromUrl() {
  const page = route.query.page
  return page ? page : 1
}

function getToPage(page) {
  current.value = page
  const query = {...route.query}
  query.page = page
  router.push({
    query
  })
}

onMounted(() => {
  const scripts = [
    '/js/core.min.js',
    '/js/script.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  loadScriptsSequentially(scripts);

  current.value = getPageFromUrl()
  get_blog_list()
  window.addEventListener('popstate', handleBrowserNavigation)
})

watch(() => route.query,
    () => {
      get_blog_list()
    },
    {immediate: true})

useHead({
  title: 'TPA Housing - 100000m2 Production Plant, 20 Years Experienced Engineer, 30 Countries House Projects',
  meta: [
    {
      name: 'description',
      content: 'content="We can provide prefabricated design expertise, construction knowledge you need to build the house you want in short time and within your budget,Steel Structure House Building,Warehouse Steel Structure,Lightweight Steel Structure and other products and services'
    }
  ]
})

onUnmounted(() => {
  window.removeEventListener('popstate', handleBrowserNavigation)
})

function handleBrowserNavigation() {
  window.location.reload()
}

</script>

<template>
  <div class="page">
    <HomeHeader/>

    <!-- Breadcrumbs -->
    <section class="bg-gray-7">
      <div class="breadcrumbs-custom box-transform-wrap context-dark">
        <div class="container">
          <h3 class="breadcrumbs-custom-title">{{ t('page.blogGrid') }}</h3>
          <div class="breadcrumbs-custom-decor"></div>
        </div>
        <div class="box-transform" style="background-image: url(/images/bg-blog.jpg);"></div>
      </div>
      <div class="container">
        <ul class="breadcrumbs-custom-path">
          <li><a href="/">{{ t('common.home') }}</a></li>
          <li class="active"><a href="/blogs">{{ t('page.blogs') }}</a></li>
        </ul>
      </div>
    </section>
    <!-- Grid Blog-->
    <section class="section section-lg bg-default">
      <div class="container">
        <div class="row row-40 row-lg-60 justify-content-center">
          <div class="col-sm-6 col-lg-4 order-lg-1" v-if="blogList && blogList.results"
               v-for="list in blogList.results">
            <!-- Post Classic-->
            <article class="post post-classic block-3">
              <div class="post-classic-figure"><img :src="list.image_1" alt="" width="370" height="210"/>
              </div>
              <div class="post-classic-content">
                <p class="post-classic-title"><a :href="'/blogs/' + list.site">{{ list.blog_title }}</a>
                </p>
              </div>
              <time class="post-classic-time" datetime="">{{ formatDate(list.updated_at) }}</time>
            </article>
          </div>
        </div>
        <div class="pagination-wrap">
          <!-- Bootstrap Pagination-->
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li @click="getToPage(prevPage)" class="page-item page-item-control"><a class="page-link"
                                                                                               href="#"
                                                                                               aria-label="Previous"><span
                  class="icon"
                  aria-hidden="true"></span></a>
              </li>
              <li v-if="blogList && blogList.results" v-for="page in pages" :key="page" class="page-item active">
                <a v-if="page === current.value" @click="getToPage(page)" class="page-link" href="#">{{ page }}</a>
                <a v-else-if="page === '...'" @click="getToPage(page)" class="page-link" href="#">{{ page }}</a>
                <a v-else @click="getToPage(page)" class="page-link" href="#">{{ page }}</a>
              </li>

              <li @click="getToPage(nextPage)" class="page-item page-item-control"><a class="page-link" href="#"
                                                                                      aria-label="Next"><span
                  class="icon" aria-hidden="true"></span></a></li>
            </ul>
          </nav>
        </div>
      </div>
    </section>

    <Footer/>
  </div>
  <!-- Global Mailform Output-->
  <div class="snackbars" id="form-output-global"></div>
</template>

<style scoped lang="scss">

</style>
